"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleAnalyticsToSplit = void 0;
var GaToSplit_1 = require("./GaToSplit");
function GoogleAnalyticsToSplit(options) {
    if (options === void 0) { options = {}; }
    // GaToSplit integration factory
    function GoogleAnalyticsToSplitFactory(params) {
        return (0, GaToSplit_1.GaToSplit)(options, params);
    }
    GoogleAnalyticsToSplitFactory.type = 'GOOGLE_ANALYTICS_TO_SPLIT';
    return GoogleAnalyticsToSplitFactory;
}
exports.GoogleAnalyticsToSplit = GoogleAnalyticsToSplit;
